export default __webpack_public_path__ + "static/paper-8488c1841e8f35a904697191fc1b009a.webp";